import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import useAssignedReviews from '@/hooks/use-assigned-reviews.ts';
import MenuDropdown from '../side-nav/components/menu-dropdown';
type ReviewsDropdownProps = {
  href: string;
  text: string;
  icon: Icon;
  isCollapsed: boolean;
  pathname: string;
};
const ReviewsDropdown = t0 => {
  const $ = _c(39);
  const {
    href,
    text,
    icon,
    isCollapsed,
    pathname
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const {
    data
  } = useAssignedReviews();
  const assignedCount = data?.length ?? 0;
  const t2 = `${href}/queues-and-teams`;
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      href: t2,
      text: t3
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `${href}/review-kinds`;
  let t6;
  if ($[6] !== t) {
    t6 = t(_temp2);
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = {
      href: t5,
      text: t6
    };
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `${href}/manage-reviewers`;
  let t9;
  if ($[11] !== t) {
    t9 = t(_temp3);
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = {
      href: t8,
      text: t9
    };
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = `${href}/assigned-reviews`;
  let t12;
  if ($[16] !== t) {
    t12 = t(_temp4);
    $[16] = t;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== assignedCount || $[19] !== data) {
    t13 = data ? <div className="text-caption-4 bg-primary border border-tertiary border-solid rounded-sm px-2 py-0.5">{assignedCount}</div> : null;
    $[18] = assignedCount;
    $[19] = data;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t12 || $[23] !== t13) {
    t14 = {
      href: t11,
      text: t12,
      suffixElement: t13
    };
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t10 || $[26] !== t14 || $[27] !== t4 || $[28] !== t7) {
    t15 = [t4, t7, t10, t14];
    $[25] = t10;
    $[26] = t14;
    $[27] = t4;
    $[28] = t7;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const subLinks = t15;
  let t16;
  if ($[30] !== assignedCount) {
    t16 = assignedCount > 0 ? <div className="w-[6px] h-[6px] bg-(--text-color-error) rounded-full" /> : null;
    $[30] = assignedCount;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const suffixElement = t16;
  let t17;
  if ($[32] !== icon || $[33] !== isCollapsed || $[34] !== pathname || $[35] !== subLinks || $[36] !== suffixElement || $[37] !== text) {
    t17 = <MenuDropdown text={text} icon={icon} isCollapsed={isCollapsed} subLinks={subLinks} pathname={pathname} suffixElement={suffixElement} />;
    $[32] = icon;
    $[33] = isCollapsed;
    $[34] = pathname;
    $[35] = subLinks;
    $[36] = suffixElement;
    $[37] = text;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};
export default ReviewsDropdown;
function _temp($) {
  return $.reviewsSubmenus.queuesAndTeams;
}
function _temp2($_0) {
  return $_0.reviewsSubmenus.reviewKinds;
}
function _temp3($_1) {
  return $_1.reviewsSubmenus.manageReviewers;
}
function _temp4($_2) {
  return $_2.reviewsSubmenus.assignedReviews;
}